import React from 'react';

import './InputBox.css';

export default class InputBox extends React.PureComponent {

    state = {
        editing: false,
    };

    render() {
        const { value, onChange, onBlur, editLabel } = this.props;
        const { editing } = this.state;

        const displayName = this.props.displayName ||
            (<span className='displayName'>
                {value}
            </span>)

        return (
            <div className={'input-box'}>
                {!editing
                    ? displayName
                    : <input
                        ref='input'
                        className='input'
                        value={value || ''}
                        onChange={event => onChange(event.target.value)}
                        disabled={!editing}
                        onBlur={() => {
                            this.setState({ editing: false });
                            if (typeof onBlur !== 'undefined' && typeof onBlur === 'function') {
                                onBlur();
                            }
                        }}
                        onKeyPress={event => {
                            if (event.key === 'Enter') {
                                event.target.blur();
                            }
                        }}
                    />}
                <span
                    className='edit'
                    onClick={() => {
                        this.setState({ editing: true }, () => {
                            this.refs.input.focus();
                            this.refs.input.select && this.refs.input.select();
                        });
                    }}>
                    {editLabel}
                </span>
            </div>
        );
    }
}
